"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLog = exports.consoleLog = void 0;
function log(delegate, level, component, msg, args) {
    if (!msg) {
        delegate("");
        return;
    }
    const timestamp = new Date().toISOString().replace("T", " ").replace("Z", "") + " UTC";
    const levelPadded = `[${level.toUpperCase()}]`.padEnd(5);
    const consoleMsg = `${timestamp} ${levelPadded}${component ? ` (${component}) ` : ""}- ${msg}`;
    if (args.length > 0) {
        delegate(consoleMsg, ...args);
    }
    else {
        delegate(consoleMsg);
    }
}
exports.consoleLog = getLog(`next-collect/${typeof window === "undefined" ? "server" : "client"}`);
function getComponentName(name) {
    return typeof name === "function" ? name() : name;
}
function getLog(componentName) {
    const partial = {
        error(msg, ...args) {
            log(console.error, "error", getComponentName(componentName), msg, args);
        },
        warn(msg, ...args) {
            log(console.warn, "warn", getComponentName(componentName), msg, args);
        },
        info(msg, ...args) {
            log(console.info, "info", getComponentName(componentName), msg, args);
        },
        debug(msg, ...args) {
            log(console.info, "debug", getComponentName(componentName), msg, args);
        },
    };
    return { log: partial.info, ...partial };
}
exports.getLog = getLog;
